import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import {
  PROOF_OF_INCOME_PINWHEEL_PAYTSTUBS,
  PROOF_OF_INCOME_OPTION_ITEMS,
} from 'common/householdApplication/incomeHelpers';

import { SR_API_ACTION_ASSEMBLY_LINE_EDIT_VOIE_DOCUMENT_TYPE } from 'api/actionTypes';

import postWithState from 'client/actions/postWithState';
import useDispatch from 'client/hooks/useDispatch';

import { createInitialValues, createFormValidationFn } from 'client/helpers/formikHelpers';

import SrText from 'client/components/SrText';
import SrBox from 'client/components/SrBox';
import SrModalV2 from 'client/components/SrModalV2/SrModalV2';

import SrInfoTile, { SR_INFO_TILE_THEME_ADMIN_GREY } from 'client/components/SrInfoTile/SrInfoTile';

import SrFormikField, { SR_FIELD_THEME_ADOBE } from 'client/components/SrFormikField';

import SrButton, {
  SR_BUTTON_THEME_ADOBE_GREY,
  SR_BUTTON_THEME_ADOBE_YELLOW,
} from 'client/components/SrButton/SrButton';

const getFormFields = ({ fromType }) => [
  {
    id: 'toType',
    type: 'select',
    properties: {
      choices: PROOF_OF_INCOME_OPTION_ITEMS.filter(({ value }) => {
        return value !== fromType && value !== PROOF_OF_INCOME_PINWHEEL_PAYTSTUBS;
      }),
    },
    validations: ['required'],
  },
];

const SrApplicationAssemblyLineUpdateDocumentsTypeModal = ({
  fromType,
  assemblyLineApplicationId,
  onClose,
}) => {
  const dispatch = useDispatch();

  const onSubmit = useCallback(
    ({ toType }) => {
      dispatch(postWithState, {
        action: SR_API_ACTION_ASSEMBLY_LINE_EDIT_VOIE_DOCUMENT_TYPE,
        payload: {
          assemblyLineApplicationId,
          fromType,
          toType,
        },
      }).then(() => {
        // We need to do a hard-reset on the Assembly line state for this to work.
        if (global.location) {
          global.location.reload();
        }
      });
    },
    [assemblyLineApplicationId, fromType, dispatch],
  );

  const formFields = getFormFields({
    fromType,
  });

  return (
    <Formik
      validate={createFormValidationFn(formFields)}
      initialValues={createInitialValues({ formFields })}
      onSubmit={onSubmit}
      render={(formikBag) => {
        return (
          <SrModalV2
            buttonTheme={SR_BUTTON_THEME_ADOBE_GREY}
            showCloseButton={false}
            onClose={onClose}
            padding="0px"
            centerContent
          >
            <Form>
              <SrBox
                padding="40px"
                background="white"
                borderRadius="24px"
                width="759px"
                height="414px"
                margin="auto"
                boxSizing="border-box"
              >
                <SrText
                  font="greycliff"
                  paddingBottom="15px"
                  lineHeight="33px"
                  size="26"
                  weight="bolder"
                  align="center"
                  display="block"
                >
                  Edit POI document type
                </SrText>
                <SrBox marginTop="20px" />
                <SrInfoTile
                  theme={SR_INFO_TILE_THEME_ADMIN_GREY}
                  label="Document type"
                  value={
                    <SrBox marginTop="-16px">
                      {formFields.map((formField) => (
                        <SrFormikField
                          key={formField.id}
                          formField={formField}
                          formikBag={formikBag}
                          theme={SR_FIELD_THEME_ADOBE}
                        />
                      ))}
                    </SrBox>
                  }
                />
                <SrBox marginTop="64px" />
                <SrButton type="submit" theme={SR_BUTTON_THEME_ADOBE_YELLOW}>
                  Update
                </SrButton>
                <SrBox marginTop="16px" />
                <SrButton theme={SR_BUTTON_THEME_ADOBE_GREY} onClick={onClose}>
                  Close
                </SrButton>
              </SrBox>
            </Form>
          </SrModalV2>
        );
      }}
    />
  );
};

SrApplicationAssemblyLineUpdateDocumentsTypeModal.propTypes = {
  fromType: PropTypes.string.isRequired,
  assemblyLineApplicationId: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
};

SrApplicationAssemblyLineUpdateDocumentsTypeModal.displayName =
  'SrApplicationAssemblyLineUpdateDocumentsTypeModal';

export default SrApplicationAssemblyLineUpdateDocumentsTypeModal;
